import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-validate-and-cancel',
  templateUrl: './validate-and-cancel.component.html',
  styleUrls: ['./validate-and-cancel.component.scss']
})
export class ValidateAndCancelComponent {
  @Input() isLoading: boolean = false;
  @Input() editForm: FormGroup;
  @Input() disabling: boolean;
  @Output() submitEvent = new EventEmitter<boolean>();

  constructor() { }

  onSubmit() {
    this.submitEvent.next(true);
  }

  onCancel() {
    this.submitEvent.next(false);
  }

}
